// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let DialogV5 = require("./DialogV5.bs.js");
let ButtonsV5 = require("./ButtonsV5.bs.js");
let Attachments = require("../../../reason/common/Attachments/Attachments.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function ConversationsSection__UnsupportedAttachmentsDialog(props) {
  let onDismiss = props.onDismiss;
  let files = props.files;
  let isOpen = files.length !== 0;
  return JsxRuntime.jsx(DialogV5.make, {
    title: "Unsupported Files",
    isOpen: isOpen,
    ariaLabel: "Unsupported Files",
    onDismiss: onDismiss,
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            Attachments.makeUnsupportedFileErrorText(files),
            JsxRuntime.jsx("br", {}),
            JsxRuntime.jsx("br", {}),
            "You can attach images (JPEG, PNG, GIF, PNG), videos (MP4, Quicktime), PDFs, documents and spreadsheets"
          ],
          className: "text-lg leading-normal"
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
            onClick: param => onDismiss(),
            size: "large",
            children: "Dismiss"
          }),
          className: "flex flex-row items-start justify-end w-full"
        })
      ],
      className: "flex flex-col items-start gap-8"
    })
  });
}

let make = ConversationsSection__UnsupportedAttachmentsDialog;

exports.make = make;
/* DialogV5 Not a pure module */
